<template>
  <div class="products-header-tags">
    <div v-for="(tag, index) in tags" :key="index" class="products-header-tag" @click="removeTag(tag)">
      <span>
        <template v-if="tag.key === 'rate'">
          {{ $tc('filters.rate', tag.value) }}
        </template>
        <template v-else-if="tag.key === 'priceMin'">
          {{ $tc('filters.priceMin', toCurrency(Number(tag.value))) }}
        </template>
        <template v-else-if="tag.key === 'priceMax'">
          {{ $tc('filters.priceMax', toCurrency(Number(tag.value))) }}
        </template>
        <template v-else>
          {{ tag.value }}
        </template>
      </span>
      <b-icon icon="close" size="is-small" />
    </div>
  </div>
</template>

<script>
import convertOptions from '~/marketplace-front-core/utils/convertOptions'

export default {
  props: {
    options: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      tags: []
    }
  },
  watch: {
    '$route.query': {
      handler (query) {
        this.tags = []
        Object.keys(query).forEach((key) => {
          if (key === 'options') {
            const options = convertOptions(query.options)

            Object.keys(options).forEach((filterId) => {
              options[filterId].forEach((optionId) => {
                const findFilter = this.options.find(x => x.id === Number(filterId))
                if (findFilter) {
                  const findOption = findFilter.options.find(x => x.id === Number(optionId))
                  if (findOption) {
                    this.tags.push({
                      key: 'options',
                      value: findOption.name,
                      option: `${filterId}-${optionId}`
                    })
                  }
                }
              })
            })
          } else if (['rate', 'priceMin', 'priceMax', 'search'].find(x => x === key)) {
            if (query[key]) {
              this.tags.push({
                key,
                value: query[key]
              })
            }
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    removeTag (tag) {
      const query = this._clone(this.$route.query)
      delete query.page

      if (tag.key === 'options') {
        const newOptions = query.options.filter(x => /-/g.test(x)).filter(x => x !== tag.option)
        if (newOptions && newOptions.length) {
          query.options = newOptions
        } else {
          delete query.options
        }
      } else {
        delete query[tag.key]
      }

      this.$router.push({ query })
    }
  }
}
</script>
